import { Route, Routes } from "react-router-dom";
import { Routes as NotificationRoutes } from "./routes";
import { NotificationRouterCmp } from "./types";
import NotificationSearchPage from "../pages/NotificationSearchPage/NotificationSearchPage";
import NotificationLogPage from "../pages/NotificationLogPage/NotificationLogPage";
import NotificationCalendarPage from "../pages/NotificationCalendarPage/NotificationCalendarPage";
import NotificationVehicleTimelinePage from "../pages/NotificationVehicleTimelinePage/NotificationVehicleTimelinePage";

const NotificationRouter: NotificationRouterCmp = () => {
  return (
    <Routes>
      <Route path={NotificationSearchPage.route} element={<NotificationSearchPage />} />
      <Route path={NotificationLogPage.route} element={<NotificationLogPage />} />
      <Route path={NotificationCalendarPage.route} element={<NotificationCalendarPage />} />
      <Route
        path={NotificationVehicleTimelinePage.route}
        element={<NotificationVehicleTimelinePage />}
      />
    </Routes>
  );
};

NotificationRouter.route = NotificationRoutes.NotificationRouter;

export default NotificationRouter;
